import { MessageOutput } from '../common-objects';

export const APPLE_STATUS_MAPPING: { [key: string]: MessageOutput } = {
    '200': MessageOutput.OK,
    '206': MessageOutput.PARTIAL,
    '201': MessageOutput.NOT_CONFIRMED,
    '10001': MessageOutput.NOT_CONFIRMED,
    '10002': MessageOutput.NOT_CONFIRMED,
    '444': MessageOutput.CANCELED,
    '403': MessageOutput.LOGIN_FAILED,
    '408': MessageOutput.TIMEOUT,
    '202': MessageOutput.NO_ELIGIBLE_DEVICE,
};

/**
 * Default folder code when locale is not found
 */
export const DEFAULT_MESSAGE = MessageOutput.TECHNICAL_ERROR;

/**
 * Maps an Apple status code to a MessageOutput
 * @param status Apple status code (e.g., '0000', 'cancel')
 * @returns Corresponding MessageOutput
 */
export function mapAppleStatusToMessage(status: string): MessageOutput {
    const normalizedStatus = status.toLowerCase();

    // Try exact match first
    if (APPLE_STATUS_MAPPING[normalizedStatus]) {
        return APPLE_STATUS_MAPPING[normalizedStatus];
    }

    // Fallback to default
    return DEFAULT_MESSAGE;
}
